<template>
  <c-page-section squares>
    <q-card class="security-tf-conditions" data-testid="security-tf-conditions">
      <q-card-section class="text-h4">{{ t('security.title') }} </q-card-section>
      <q-card-section class="text-h5">{{ t('security.subtitle') }} </q-card-section>
      <q-card-section class="text-h7">{{ t('security.description') }} </q-card-section>
      <q-separator />
      <q-card-section>
        <div v-for="n in 2" :key="n" class="no-wrap q-mb-md">
          <div class="text-h5 q-px-sm">
            {{ t(`security.section${n}.description`) }}
          </div>
          <ul class="section">
            <li v-for="z in locale[n]" :key="z" div class="no-wrap">
              <div class="text-h7 q-py-sm">
                {{ z }}
              </div>
            </li>
          </ul>
        </div>
      </q-card-section>
      <q-separator />
      <q-card-section v-if="t('security.urlLabel') !== ''" class="text-h7"
        >{{ t('security.end') }}
        <!-- eslint-disable sonarjs/no-vue-bypass-sanitization -->
        <a :href="securityUrl" target="_blank" data-testid="confluence-link">
          {{ t('security.urlLabel') }}
          <q-icon name="mdi-open-in-new" />
        </a>
        <!-- eslint-enable sonarjs/no-vue-bypass-sanitization -->
      </q-card-section>
      <q-separator v-if="slots.button" />
      <slot name="button"></slot>
    </q-card>
  </c-page-section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { ref, useSlots } from 'vue';
import CPageSection from '@/components/_common/PageSection.vue';
import { getConfig } from '@/config';
const config = getConfig();
/*****************************************************************************
 * SETUP
 ****************************************************************************/

const slots = useSlots();

const BLANK_LOCALE = {};
const { t, tm } = useI18n();
const locale = ref(BLANK_LOCALE);
const securityUrl = config.SECURITY_WIKI_PAGE_URL;

locale.value[1] = tm('security.section1.points');
locale.value[2] = tm('security.section2.points');
</script>
<style lang="scss">
@import 'styles/app.variables.scss';
.security-tf-conditions {
  .card-image {
    width: 11rem;
    flex-shrink: 0;

    @media screen and (max-width: $bp820) {
      width: 8rem;
    }
  }
  img {
    width: 100% !important;
    border-radius: 0;
  }
  .section {
    font-family: sans-serif;
    border: 1px solid #eee;
    border-radius: 2px;
    padding: 20px 30px;
    margin-top: 1em;
    user-select: none;
    overflow-x: auto;
  }
}

a:link,
a:visited {
  color: $blue;
}

a:hover,
a:active {
  color: $blue-80;
}
</style>
